import { Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: "bold",
    margin: theme.spacing(2, 0, 3, 0),
  },
}));

const MenuTitle = ({ title }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Typography className={classes.title} align="center" gutterBottom>
      {t(title)}
    </Typography>
  );
};

export default MenuTitle;
